import {Box, Typography} from '@mui/material';
import './ConcurrentUserWarning.scss';
import {ReactComponent as InfoIcon} from '../../../../../assets/images/info-icon.svg';
import {useDispatch} from 'react-redux';
import {clearRedactionEvents} from '../../../../../redux/slice/signalrSlice';
import {useCallback} from 'react';
import {t} from 'i18next';

const ConcurrentUserWarning = ({showWarning}: {showWarning: boolean}) => {
  const dispatch = useDispatch();

  const handleReloadClick = useCallback(() => {
    dispatch(clearRedactionEvents());
    window.location.reload();
  }, [dispatch]);

  if (!showWarning) return null;
  return (
    <Box className="concurrent-user-warning-box">
      <InfoIcon />
      <Typography
        className="typo-text body4_size text-color"
        component={'span'}
        data-testid={`warning-text`}
      >
        {t('docView.concurrentUserWarning')}
        <Typography
          component="span"
          role="button"
          tabIndex={0}
          className="typo-text buttonXS_size text-link"
          onClick={handleReloadClick}
          data-testid="reload-page-link"
        >
          {t('docView.reloadPage')}
        </Typography>
      </Typography>
    </Box>
  );
};

export default ConcurrentUserWarning;
